export const selectLang = state => state.lang.eng;
export const selectButtons = state => state.lang.buttons;
export const selectInputs = state => state.lang.inputs;
export const selectSelects = state => state.lang.selects;
export const selectTexts = state => state.lang.texts;
export const selectErrors = state => state.lang.errors;